module.exports = __webpack_public_path__ + "static/media/team-illustration--cropped@1x.6f1be7d7.png";